var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-list',{staticStyle:{"column-count":"2"}},_vm._l((_vm.apps),function(app){return _c('v-list-item',{key:app},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(app))])],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }